import React from 'react'
import './Style/Product.css'
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import {product} from './modal'
function Product({data,DateDay}) {
  return <div className="report">
    <div className='container'>
      <table className='table-products' id="table-invoice">
        <thead >
            <tr>
                <th> SL. </th>
                <th>Description</th>
                <th>Price</th>
                <th>QTY</th>
                <th>Total</th>
            </tr>
        </thead>

        {data.map((item,key)=>(
            <tr key={key}>
                  <td> {item.id} </td>
                  <td>{item.description} </td>
                  <td> ${item.price} </td>
                  <td> {item.qty} </td>
                  <td> ${item.price * item.qty} </td>
            </tr>
        ))}
      </table>
    </div>
    <div className='button-export-to-exsel'>
      <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-invoice"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Print To Excel"
      />
  </div>
</div>
}

export default Product